"use client";

import { createContext, type ReactNode, useContext } from "react";

import { Loan } from "../../data/types";

import { type LoanDetailsState, useLoanDetailsState } from "./useLoanDetailsState";

const LoanDetailsContext = createContext<LoanDetailsState | undefined>(undefined);

export function useLoanDetails() {
  const context = useContext(LoanDetailsContext);
  if (!context) throw new Error("useLoanDetails must be called within a LoanDetailsProvider");
  return context;
}

interface LoanDetailsProviderProps {
  loan: Loan;
  children: ReactNode;
}

export function LoanDetailsProvider(props: LoanDetailsProviderProps) {
  const { loan, children } = props;

  const state = useLoanDetailsState(loan);

  return <LoanDetailsContext.Provider value={state}>{children}</LoanDetailsContext.Provider>;
}
